import Link from 'next/link'
import type { LinkProps } from 'next/link'
import { tv } from 'tailwind-variants'

import type { Color } from '@nxt-insurance/ui-kit/types'

import { MultiColoredImage } from '@/components/renderers/MultiColoredImage'
import { EVENTS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'

const iconStyles = tv({
  slots: {
    link: 'rounded-sm bg-ui-light p-2',
  },
})

const FaIcon = (
  props: Pick<LinkProps, 'href'> & {
    iconName: 'twitter' | 'instagram' | 'tiktok' | 'linkedin' | 'medium' | 'youtube'
    color?: Color
  }
) => {
  const { track } = useAnalytics()
  const styles = iconStyles()

  return (
    <Link
      className={styles.link()}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={props.iconName}
      href={props.href}
      onClick={() => {
        track(EVENTS.SocialMediaButtonClicked, { name: props.iconName })
      }}
    >
      <MultiColoredImage
        node={{
          // required by the type but not used
          index: 0,
          // required by the type but not used
          isInline: true,
          // required by the type but not used
          renderNode: () => null,
          value: {
            _type: 'multiColoredImage',
            color: 'brandDark',
            image: props.iconName,
          },
        }}
      />
    </Link>
  )
}

export const SocialMediaIcons = (props: { pageColor?: Color }) => {
  return (
    <div className="flex flex-row gap-x-2.5 pb-8">
      <FaIcon
        href="https://www.instagram.com/hellogetsafe/"
        iconName="instagram"
        color={props.pageColor}
      />
      <FaIcon
        href="https://www.tiktok.com/@hellogetsafe"
        iconName="tiktok"
        color={props.pageColor}
      />
      <FaIcon
        href="https://www.linkedin.com/company/9434196/"
        iconName="linkedin"
        color={props.pageColor}
      />
      <FaIcon href="https://medium.com/hellogetsafe" iconName="medium" color={props.pageColor} />
      <FaIcon
        href="https://www.youtube.com/channel/UC6KYPy4DiAqpghvvwG6lAxw"
        iconName="youtube"
        color={props.pageColor}
      />
    </div>
  )
}
